// ANALYSIS AND CHANGES:
// 1. FONT STANDARDIZATION:
//    - The modal title ("CONFIRM DELETE") now uses the `font-azonix` class.
//    - The confirmation text now uses the Paragraph component with the `font-coda` font.
//    - As fontes obsoletas (`Android_101`, `Barlow`) foram completamente removidas.
// 2. LIMPEZA DE ESTILOS:
//    - All hardcoded color and background classes were removed.
//    - The component now correctly inherits the dark theme styles defined in `index.css`.
// 3. STANDARDIZED BUTTONS:
//    - The confirm button ("Yes, delete") now uses the Ant Design `danger: true` prop, which applies the correct danger style from the theme.

import { UserData, useUsers } from '@hooks';
import { Button, Modal, Typography } from 'antd';

const { Paragraph, Text } = Typography;

interface DeleteUserModalProps {
  open: boolean;
  onCancel: () => void;
  user: UserData | null;
  onSuccess?: () => void;
}

export const DeleteUserModal = ({ open, onCancel, user, onSuccess }: DeleteUserModalProps) => {
  const { deleteUser } = useUsers();

  const handleDelete = async () => {
    if (!user) return;

    try {
      await deleteUser.mutateAsync(user.id);
      onCancel();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  return (
    <Modal
      title={<span className="font-azonix !font-normal text-xl">CONFIRM DELETE</span>}
      open={open}
      width={550}
      onCancel={onCancel}
      destroyOnClose
      footer={
        <div className="pt-4 flex justify-end gap-2">
          <Button onClick={onCancel} className="btn-single-cut">
            CANCEL
          </Button>
          <Button
            onClick={handleDelete}
            loading={deleteUser.isPending}
            className="btn-single-cut btn-single-cut-cancel"
          >
            Yes, delete
          </Button>
        </div>
      }
    >
      <Paragraph className="font-coda text-white !my-4">
        Are you sure you want to delete the user{' '}
        <Text className="text-primary">
          {user?.physicalPerson?.name || user?.email}
        </Text>
        ? This action cannot be undone.
      </Paragraph>
    </Modal>
  );
};
